class StatisticItem extends HTMLElement {
  constructor() {
    super();
    this.targetValue = parseInt(this.dataset.percentage || 0, 10);
    this.duration = parseInt(this.dataset.duration || 2000, 10);

    this.numberEl = this.querySelector('.statistic__number');
    this.barEl = this.querySelector('.statistic__bar');

    this.observer = null;
  }

  connectedCallback() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    this.numberEl.textContent = '0';

    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  handleIntersect(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.animate();
        observer.unobserve(entry.target);
      }
    });
  }

  animate() {
    if (!this.numberEl || !this.barEl) return;

    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / this.duration, 1);

      const currentNumber = Math.floor(progress * this.targetValue);
      this.numberEl.textContent = currentNumber;

      this.barEl.style.height = `${progress * this.targetValue}%`;

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }
}

customElements.define('statistic-item', StatisticItem);
